import { Brand } from 'constants/brand';

export const TITLE_CONFIG = {
  [Brand.FM]: 'Fusion Markets',
  [Brand.GP]: 'Global Prime',
  [Brand.DAY1]: 'Day1x',
};
